import React from 'react';
import { cn, getStatusColor } from '@/lib/utils';
import { Server, Monitor, Cloud, Wifi, Shield, AlertTriangle, CheckCircle } from 'lucide-react';

const categoryConfig = {
  network: { icon: Wifi, label: 'NETWORK' },
  endpoints: { icon: Monitor, label: 'ENDPOINTS' },
  servers: { icon: Server, label: 'SERVERS' },
  cloud: { icon: Cloud, label: 'CLOUD' },
  iot: { icon: Shield, label: 'IoT' },
};

export function EnvironmentOverview({ stats = {} }) {
  const categories = Object.entries(stats).map(([key, data]) => ({
    key,
    ...categoryConfig[key],
    ...data
  }));

  return (
    <div className="space-y-4" data-testid="environment-overview">
      <h3 className="font-display text-sm uppercase tracking-wider text-muted-foreground">
        Visão do Ambiente
      </h3>
      
      <div className="grid grid-cols-1 gap-3">
        {categories.map((cat) => {
          const Icon = cat.icon || Server;
          const total = cat.total || 0;
          const ok = cat.ok || 0;
          const warning = cat.warning || 0;
          const critical = cat.critical || 0;
          
          return (
            <div 
              key={cat.key}
              className="bg-secondary/50 rounded-sm p-3 border border-border hover:border-primary/50 transition-colors"
            >
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-2">
                  <Icon className="h-4 w-4 text-muted-foreground" />
                  <span className="font-display text-xs uppercase tracking-wider">{cat.label}</span>
                </div>
                <span className="font-mono text-base">{total}</span>
              </div>
              
              {/* Status indicators */}
              <div className="flex items-center gap-3 mt-2">
                {ok > 0 && (
                  <div className="flex items-center gap-1.5">
                    <div className="h-2 w-2 rounded-full bg-success" />
                    <span className="text-xs font-mono text-success">{ok}</span>
                  </div>
                )}
                {warning > 0 && (
                  <div className="flex items-center gap-1.5">
                    <div className="h-2 w-2 rounded-full bg-warning animate-pulse" />
                    <span className="text-xs font-mono text-warning">{warning}</span>
                  </div>
                )}
                {critical > 0 && (
                  <div className="flex items-center gap-1.5">
                    <div className="h-2 w-2 rounded-full bg-destructive animate-pulse" />
                    <span className="text-xs font-mono text-destructive">{critical}</span>
                  </div>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default EnvironmentOverview;
